module.exports = __webpack_public_path__ + "assets/img/owner-banner.ab9d69bb.png";